// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Backdrop_backdrop__1mZAf","content":"Backdrop_content__26Rv2","layer":"Backdrop_layer__3vdPf"};